/**
 * Fixes the CustomEvent implementation of IE 11 (CustomEvent should be a method)
 * from: https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent#Polyfill
 *
 * @returns {boolean}
 */
export default function customEvent () {
  if (typeof window.CustomEvent === 'function') return false
  function CustomEvent (event, params) {
    params = params || { bubbles: false, cancelable: false, detail: null }
    var evt = document.createEvent('CustomEvent')
    evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail)
    return evt
  }
  window.CustomEvent = CustomEvent
  return true
}
